import { settings } from '../settings.js';

const counter = {};

const setCounter = () => {
    counter.beadNumber = 1;
    counter.row = 1;
    counter.side = 1;
    counter.square = 1;
};

const rotate = ({x: _x, y: _y, angle}) => ({
    x: _x * Math.cos(angle) - _y * Math.sin(angle),
    y: _y * Math.cos(angle) + _x * Math.sin(angle)
});


export const applyStar = ({bead, i, viewName, rowLengths}) => {

    if (i === 0) setCounter();

    const gridArrangement = {
        x: 30 + (counter.row - 1) * 22,
        y: ((counter.beadNumber - 1) * 30 * 2) - ((counter.row - 1) * 30)
    };

    const onOddSide = [2, 4].some(element => element === counter.side);

    const panelAngle = Math.PI * 0.6;

    const firstArrangement = onOddSide ?
        gridArrangement :
        rotate({...gridArrangement, angle: panelAngle});

    // work out center of star

    const xIncrement = 22.04;
    const yIncrement = 30.2;

    const xOrigin = 118;
    const yOrigin = 162;

    const rotatePoint = {
        x: xOrigin + (settings.rows - 5) * xIncrement,
        y: yOrigin + (settings.rows - 5) * yIncrement
    };

    // translate so center is around (0, 0)

    const translatedToOrigin = {
        x: firstArrangement.x - rotatePoint.x,
        y: firstArrangement.y - rotatePoint.y
    };

    // rotate

    const starRotation = Math.PI * 0.4 * (counter.square - 1);
    const rotated = rotate({...translatedToOrigin, angle: starRotation});

    if (viewName === 'B') rotated.x = -rotated.x; // flip the back views

    // translate back again

    const translatedBackAgain = {
        x: rotated.x + rotatePoint.x,
        y: rotated.y + rotatePoint.y
    };

    // work out angle of bead

    const beadAngle = starRotation + (onOddSide ? 0 : Math.PI * 0.6);
    const myAngle = viewName === 'F' ? beadAngle : -beadAngle;

    bead.setAngle(myAngle * 180 / Math.PI);

    // translate bead on canvas

    const translateDistance = {x: 400, y: 400};
    const translateIncrement = {x: 22, y: 18}

    const result = {
        x: translatedBackAgain.x + translateDistance.x + (settings.rows * translateIncrement.x),
        y: translatedBackAgain.y + translateDistance.y + (settings.rows * translateIncrement.y),
    };

    bead.x = result.x;
    bead.y = result.y;

    // move beads away if ignoring them

    if (bead.ignore) {
        bead.x = -100;
        bead.y = -100;
    }

    // Update counters

    counter.beadNumber++;

    if (counter.beadNumber > rowLengths[counter.row - 1]) {
        counter.beadNumber = 1;
        counter.row++;
    }
    if (counter.row > settings.rows) {
        counter.row = 1;
        counter.side++;
    }
    if (counter.side > 4) {
        counter.side = 1;
        counter.square++;
    }

    // decide if to hide the beads

    if (viewName === 'F') {
        bead.hidden = (bead.star?.side > 2) // front
    } else if (viewName === 'B') {
        bead.hidden = (bead.star?.side < 3) // back

        // add star point beads
        if (
            bead.star?.side < 3 &&
            bead.star?.row === settings.rows &&
            bead.star?.beadNumber === 1
        ) {
            bead.hidden = false;
        }
    }
};
